import { css } from '@emotion/css';
import { useMediaQuery } from 'react-responsive';

/** 오릭스 차량 리스트 배너 */
export const OrixBanner = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const desktopStyle = css`
    width: 100%;
    max-width: 1060px;
    height: 160px;
    margin: 0 auto 27px auto;
    box-sizing: border-box;
    color: #fff;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%; /* 39px */
    border-radius: 8px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 54.25%),
      url('./orix_banner.png');
  `;

  const mobileStyle = css`
    width: 100%;
    // height: 97px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    padding: 25px 16px;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 54.25%),
      url('./orix_banner_mobile.png');
    background-position: center;
    background-size: cover;
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%; /* 20.8px */
  `;

  const logoSize = isMobile ? 52 : 113;

  if (isMobile) {
    return (
      <div className={mobileStyle}>
        <div>
          <p>
            일본 대형 렌트사{' '}
            <span
              className={css`
                color: #ffc727;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%;
              `}
            >
              오릭스
            </span>
            와 함께 하는
          </p>
          <p>편안한 오키나와 여행</p>
        </div>
      </div>
    );
  }
  return (
    <div className={desktopStyle}>
      <div>
        <p>
          믿음직한 일본 대형 렌트사{' '}
          <span
            className={css`
              color: #ffc727;
              font-size: 30px;
              font-style: normal;
              font-weight: 600;
              line-height: 130%;
            `}
          >
            오릭스
          </span>
          와 함께 하는{' '}
        </p>
        <p>편안한 오키나와 여행</p>
      </div>
    </div>
  );
};
